export const getNumberSuffix = (number: number) => {
  if (number % 100 === 11 || number % 100 === 12 || number % 100 === 13) {
    return 'th';
  } else if (number % 10 === 1) {
    return 'st';
  } else if (number % 10 === 2) {
    return 'nd';
  } else if (number % 10 === 3) {
    return 'rd';
  } else {
    return 'th';
  }
};
